export default class LazyLoadImages {

	constructor() {
		const lazyImgs = document.querySelectorAll("[loading='lazy']");

		lazyImgs.forEach((img) => {
			if (img.complete && img.naturalHeight !== 0) {
				img.classList.add('lazyloaded');
			} else {
				img.addEventListener('load', () => {
					img.classList.add('lazyloaded');
				});
			}
		});
	}
}
